/** API datetimes are always UTC with a Z suffix. Parse as UTC; display in local time. */
export const formatApiTokenDate = (utcIsoString: string): string => {
  if (!utcIsoString) return '—';
  const parsed = new Date(utcIsoString);
  if (Number.isNaN(parsed.getTime())) {
    return utcIsoString;
  }
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(parsed);
};

export const daysUntilExpiry = (expiresAtUtc: string): number => {
  const ms = new Date(expiresAtUtc).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
};
